import { render, staticRenderFns } from "./B2bAssessmentPage.vue?vue&type=template&id=8b23aae6&scoped=true"
import script from "./B2bAssessmentPage.vue?vue&type=script&lang=js"
export * from "./B2bAssessmentPage.vue?vue&type=script&lang=js"
import style0 from "./B2bAssessmentPage.vue?vue&type=style&index=0&id=8b23aae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b23aae6",
  null
  
)

export default component.exports